module.exports = __webpack_public_path__ + "img/news-02.84a229e9.png";